var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPackage = function SvgIconPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 .983c-.302 0-.598.08-.86.229L7.043 3.517l-.068.038-4.08 2.295-.004.002a1.76 1.76 0 0 0-.58.532 1 1 0 0 0-.122.205A1.76 1.76 0 0 0 2 7.373v9.254a1.76 1.76 0 0 0 .89 1.52l.004.003 8.246 4.638a1.73 1.73 0 0 0 1.72 0l8.246-4.638.003-.002a1.76 1.76 0 0 0 .891-1.52l-1-.006h1V7.373a1.76 1.76 0 0 0-.183-.771 1 1 0 0 0-.134-.227 1.76 1.76 0 0 0-.574-.523l-8.25-4.64A1.73 1.73 0 0 0 12 .983M4 16.477V8.638l7.08 3.946-.067 7.838zm9.014 3.93L20 16.477V8.653l-2.406 1.367v4.277a1 1 0 0 1-2 0v-3.14l-2.514 1.428zm-.934-9.555 2.481-1.41-7.056-3.89L5.05 6.932zm6.885-3.911-2.364 1.343-7.045-3.886L12 3.023z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPackage;